


export enum UrlCheck {
  url = '/',
  prev = '/',
  next = '/'
}
